import { forwardRef } from 'react';
import { PostloadedIframe as PostloadedIframe$1 } from '@pm2/react-utils';
import { fadeInCls } from './comp.content.style.js';
import { jsx } from 'react/jsx-runtime';

const PostloadedIframe = /*#__PURE__*/forwardRef(function PostloadedIframe(props, ref) {
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: fadeInCls,
    children: /*#__PURE__*/jsx(PostloadedIframe$1, {
      ...props,
      src: props.src ? window.gProxy.forwardTo(props.src) : undefined
    })
  });
});

export { PostloadedIframe };
//# sourceMappingURL=atom.postloaded-iframe.js.map
